import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import { useTrackAction } from '@paradigm/features/src/analytics';
import ToggleButton from './components/ToggleButton';

export default function StrategyButtons() {
  const { options, selectedOption } = useRfqBuilderView().strategyShortcut;
  const { selectStrategy } = useRfqBuilderActions();
  const trackAction = useTrackAction();

  const handleOnChange = useCallback(
    (strategyCode: string | null) => {
      return () => {
        trackAction('update strategy', { strategyCode });
        selectStrategy(strategyCode);
      };
    },
    [selectStrategy, trackAction],
  );

  return useMemo(
    () => (
      <>
        {options.map((option) => {
          return (
            <ToggleButton
              ariaLabel={option.label}
              key={option.value}
              disabled={option.isDisabled}
              active={option.value === selectedOption?.value}
              onClick={handleOnChange(option.value)}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </>
    ),
    [handleOnChange, options, selectedOption?.value],
  );
}
